"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigQueryMatchType = exports.isBigQueryDatasourceConfig = exports.isBigQueryDatasourceConfigRequest = void 0;
const isBigQueryDatasourceConfigRequest = (cfg) => {
    return cfg !== null && 'dataset_id' in cfg && 'table_id' in cfg;
};
exports.isBigQueryDatasourceConfigRequest = isBigQueryDatasourceConfigRequest;
const isBigQueryDatasourceConfig = (cfg) => {
    return cfg !== null && 'dataset_id' in cfg && 'table_id' in cfg;
};
exports.isBigQueryDatasourceConfig = isBigQueryDatasourceConfig;
var BigQueryMatchType;
(function (BigQueryMatchType) {
    BigQueryMatchType["IN"] = "IN";
    BigQueryMatchType["NOT_IN"] = "NOT IN";
    BigQueryMatchType["EQ"] = "=";
    BigQueryMatchType["GT"] = ">";
    BigQueryMatchType["LT"] = "<";
    BigQueryMatchType["GTE"] = ">=";
    BigQueryMatchType["LTE"] = "<=";
    BigQueryMatchType["NEQ"] = "!=";
    BigQueryMatchType["EQ_OEL"] = "%=";
    BigQueryMatchType["EQ_OER"] = "=%";
    BigQueryMatchType["EQ_OEB"] = "%=%";
    BigQueryMatchType["GTE_OEL"] = "%>=";
    BigQueryMatchType["GTE_OER"] = ">=%";
    BigQueryMatchType["GTE_OEB"] = "%>=%";
    BigQueryMatchType["LTE_OEL"] = "%<=";
    BigQueryMatchType["LTE_OER"] = "<=%";
    BigQueryMatchType["LTE_OEB"] = "%<=%";
    BigQueryMatchType["GT_OEOL"] = "%>";
    BigQueryMatchType["GT_OEOR"] = ">%";
    BigQueryMatchType["GT_OEOB"] = "%>%";
    BigQueryMatchType["LT_OEL"] = "%<";
    BigQueryMatchType["LT_OER"] = "<%";
    BigQueryMatchType["LT_OEB"] = "%<%";
    BigQueryMatchType["NEQ_OEL"] = "%!=";
    BigQueryMatchType["NEQ_OER"] = "!=%";
    BigQueryMatchType["NEQ_OEB"] = "%!=%";
})(BigQueryMatchType = exports.BigQueryMatchType || (exports.BigQueryMatchType = {}));
